var _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

_global.SENTRY_RELEASE = {
  id: "ed2816a7ef71fd9ae7f9852adb8e5c12f178dc97"
};